var _ellipse, _ellipse2, _mask, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8496_4366)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.3125,
    cy: 23.6251,
    rx: 8.3125,
    ry: 4.375,
    fill: "black",
    fillOpacity: 0.35
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.4873,
    cy: 23.1,
    rx: 6.5625,
    ry: 3.5,
    fill: "black",
    fillOpacity: 0.35
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_8496_4366",
    maskUnits: "userSpaceOnUse",
    x: 1.625,
    y: -0.352417,
    width: 14,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.625,
    y: -0.352417,
    width: 14,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0035 10.2267C10.4585 9.52551 10.6933 8.35577 11.2941 7.70168C11.9819 6.95269 12.4045 5.93697 12.4045 4.81842C12.4045 2.51493 10.6124 0.647583 8.40172 0.647583C6.19104 0.647583 4.39893 2.51493 4.39893 4.81842C4.39893 5.91724 4.80673 6.91681 5.47323 7.66179C6.06659 8.325 6.28705 9.50394 5.73908 10.2051C2.13509 14.8167 2.57563 21.7897 2.72351 23.3241C2.74316 23.5281 2.8216 23.715 2.96863 23.8577C3.51756 24.3905 5.17354 25.6725 8.39966 25.6725C11.6292 25.6725 13.2853 24.3878 13.8324 23.856C13.9783 23.7142 14.0564 23.5291 14.0764 23.3267C14.226 21.8112 14.6673 14.9406 11.0035 10.2267Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0035 10.2267C10.4585 9.52551 10.6933 8.35577 11.2941 7.70168C11.9819 6.95269 12.4045 5.93697 12.4045 4.81842C12.4045 2.51493 10.6124 0.647583 8.40172 0.647583C6.19104 0.647583 4.39893 2.51493 4.39893 4.81842C4.39893 5.91724 4.80673 6.91681 5.47323 7.66179C6.06659 8.325 6.28705 9.50394 5.73908 10.2051C2.13509 14.8167 2.57563 21.7897 2.72351 23.3241C2.74316 23.5281 2.8216 23.715 2.96863 23.8577C3.51756 24.3905 5.17354 25.6725 8.39966 25.6725C11.6292 25.6725 13.2853 24.3878 13.8324 23.856C13.9783 23.7142 14.0564 23.5291 14.0764 23.3267C14.226 21.8112 14.6673 14.9406 11.0035 10.2267Z",
    fill: "url(#paint0_linear_8496_4366)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8324 23.856L13.5072 23.5213L13.8324 23.856ZM14.0764 23.3267L13.612 23.2808L14.0764 23.3267ZM2.96863 23.8577L3.29366 23.5228L2.96863 23.8577ZM11.2941 7.70168L10.9503 7.38602L11.2941 7.70168ZM11.0035 10.2267L10.6351 10.5131L11.0035 10.2267ZM11.9379 4.81842C11.9379 5.81795 11.5606 6.72156 10.9503 7.38602L11.6378 8.01735C12.4033 7.18382 12.8712 6.05599 12.8712 4.81842H11.9379ZM8.40172 1.11425C10.3368 1.11425 11.9379 2.75439 11.9379 4.81842H12.8712C12.8712 2.27547 10.888 0.180916 8.40172 0.180916V1.11425ZM4.86559 4.81842C4.86559 2.75439 6.46667 1.11425 8.40172 1.11425V0.180916C5.91541 0.180916 3.93226 2.27547 3.93226 4.81842H4.86559ZM5.82103 7.35063C5.22966 6.68965 4.86559 5.80033 4.86559 4.81842H3.93226C3.93226 6.03415 4.38379 7.14398 5.12544 7.97295L5.82103 7.35063ZM3.18802 23.2794C3.11598 22.5319 2.97134 20.4426 3.28723 17.9779C3.60384 15.5075 4.37746 12.7053 6.10678 10.4925L5.37138 9.91776C3.49671 12.3165 2.68861 15.3067 2.36146 17.8592C2.03359 20.4175 2.18315 22.582 2.25899 23.3689L3.18802 23.2794ZM8.39966 25.2059C5.31225 25.2059 3.76881 23.984 3.29366 23.5228L2.64359 24.1925C3.26631 24.797 5.03483 26.1392 8.39966 26.1392V25.2059ZM13.5072 23.5213C13.0338 23.9814 11.4903 25.2059 8.39966 25.2059V26.1392C11.7681 26.1392 13.5368 24.7941 14.1577 24.1906L13.5072 23.5213ZM10.6351 10.5131C12.3964 12.7793 13.1841 15.5839 13.5073 18.037C13.83 20.4857 13.6848 22.5437 13.612 23.2808L14.5408 23.3725C14.6177 22.5941 14.7679 20.4591 14.4327 17.9151C14.098 15.3756 13.2744 12.388 11.372 9.94033L10.6351 10.5131ZM14.1577 24.1906C14.3943 23.9607 14.5117 23.6672 14.5408 23.3725L13.612 23.2808C13.6011 23.3909 13.5623 23.4677 13.5072 23.5213L14.1577 24.1906ZM2.25899 23.3689C2.28755 23.6652 2.40518 23.9611 2.64359 24.1925L3.29366 23.5228C3.23802 23.4688 3.19878 23.3909 3.18802 23.2794L2.25899 23.3689ZM5.12544 7.97295C5.35462 8.22911 5.52185 8.60023 5.57142 8.97967C5.62115 9.36035 5.54694 9.69311 5.37138 9.91776L6.10678 10.4925C6.47919 10.0159 6.56873 9.40865 6.49689 8.85876C6.42489 8.30764 6.1852 7.75768 5.82103 7.35063L5.12544 7.97295ZM10.9503 7.38602C10.5818 7.78735 10.3351 8.33234 10.2571 8.88084C10.1793 9.42828 10.2635 10.035 10.6351 10.5131L11.372 9.94033C11.1986 9.71725 11.1277 9.38846 11.1812 9.01221C11.2345 8.63702 11.4056 8.2701 11.6378 8.01735L10.9503 7.38602Z",
    fill: "#156744",
    mask: "url(#path-3-outside-1_8496_4366)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8496_4366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 13,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0035 10.2267C10.4585 9.52551 10.6933 8.35577 11.2941 7.70168C11.9819 6.95269 12.4045 5.93697 12.4045 4.81842C12.4045 2.51493 10.6124 0.647583 8.40172 0.647583C6.19104 0.647583 4.39893 2.51493 4.39893 4.81842C4.39893 5.91724 4.80673 6.91681 5.47323 7.66179C6.06659 8.325 6.28705 9.50394 5.73908 10.2051C2.13509 14.8167 2.57563 21.7897 2.72351 23.3241C2.74316 23.5281 2.8216 23.715 2.96863 23.8577C3.51756 24.3905 5.17354 25.6725 8.39966 25.6725C11.6292 25.6725 13.2853 24.3878 13.8324 23.856C13.9783 23.7142 14.0564 23.5291 14.0764 23.3267C14.226 21.8112 14.6673 14.9406 11.0035 10.2267Z",
    fill: "url(#paint1_linear_8496_4366)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8496_4366)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85998 10.2267C9.31499 9.52551 9.54978 8.35577 10.1505 7.70168C10.8384 6.95269 11.261 5.93697 11.261 4.81842C11.261 2.51493 9.46885 0.647583 7.25817 0.647583C5.04748 0.647583 3.25537 2.51493 3.25537 4.81842C3.25537 5.91724 3.66317 6.91681 4.32968 7.66179C4.92303 8.325 5.1435 9.50394 4.59552 10.2051C0.991539 14.8167 1.43208 21.7897 1.57995 23.3241C1.59961 23.5281 1.67804 23.715 1.82507 23.8577C2.374 24.3905 4.02999 25.6725 7.25611 25.6725C10.4857 25.6725 12.1417 24.3878 12.6889 23.856C12.8347 23.7142 12.9129 23.5291 12.9329 23.3267C13.0825 21.8112 13.5237 14.9406 9.85998 10.2267Z",
    fill: "url(#paint2_linear_8496_4366)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14416 10.2267C7.59917 9.52551 7.83396 8.35577 8.43468 7.70168C9.12256 6.95269 9.54515 5.93697 9.54515 4.81842C9.54515 2.51493 7.75303 0.647583 5.54235 0.647583C3.33166 0.647583 1.53955 2.51493 1.53955 4.81842C1.53955 5.91724 1.94735 6.91681 2.61386 7.66179C3.20721 8.325 3.42768 9.50394 2.8797 10.2051C-0.724281 14.8167 -0.283745 21.7897 -0.135868 23.3241C-0.116212 23.5281 -0.0377783 23.715 0.109251 23.8577C0.658184 24.3905 2.31417 25.6725 5.54029 25.6725C8.76983 25.6725 10.4259 24.3878 10.9731 23.856C11.1189 23.7142 11.1971 23.5291 11.217 23.3267C11.3667 21.8112 11.8079 14.9406 8.14416 10.2267Z",
    fill: "url(#paint3_linear_8496_4366)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39942 25.6589C5.54774 25.5193 4.05591 24.3582 3.5404 23.8578C3.39337 23.7151 3.31494 23.5282 3.29528 23.3242C3.14741 21.7898 2.70687 14.8168 6.31085 10.2052C6.85883 9.50406 6.63837 8.32513 6.04501 7.66191C5.3785 6.91694 4.9707 5.91736 4.9707 4.81854C4.9707 2.71742 6.46177 0.979175 8.40148 0.689972C8.21466 0.662118 8.02367 0.647705 7.82946 0.647705C5.61877 0.647705 3.82666 2.51505 3.82666 4.81854C3.82666 5.91736 4.23446 6.91694 4.90097 7.66191C5.49432 8.32513 5.71478 9.50406 5.16681 10.2052C1.56283 14.8168 2.00336 21.7898 2.15124 23.3242C2.1709 23.5282 2.24933 23.7151 2.39636 23.8578C2.94529 24.3906 4.60128 25.6727 7.8274 25.6727C8.02386 25.6727 8.2145 25.6679 8.39942 25.6589Z",
    fill: "#0F7248"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18966,
    cy: 2.49749,
    rx: 2.18966,
    ry: 2.49749,
    transform: "matrix(0.982001 0.188877 -0.174437 0.984668 5.2998 1.00757)",
    fill: "#FFFDF2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32915 3.69015C6.14459 4.26972 5.97491 4.76116 5.67517 4.65753C5.37543 4.5539 5.28205 4.00005 5.46661 3.42049C5.65117 2.84092 6.04377 2.4551 6.34351 2.55874C6.64325 2.66237 6.5137 3.11059 6.32915 3.69015Z",
    fill: "#FFFDF6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8496_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11326 25.6726C3.42706 19.4759 5.73344 13.1601 6.9724 10.7767C5.60001 14.8284 5.82874 22.5941 6.11466 25.9705L4.11326 25.6726Z",
    fill: "url(#paint4_linear_8496_4366)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11288 25.6726C3.42669 19.4759 4.3988 13.458 6.97202 10.7767C5.25655 14.9476 4.97062 22.5941 5.25654 25.9705L4.11288 25.6726Z",
    fill: "url(#paint5_linear_8496_4366)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8496_4366",
    x: -1.14355,
    y: -1.97742,
    width: 16.7998,
    height: 30.275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3125,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8496_4366",
    x: -2.56771,
    y: -1.68575,
    width: 16.2165,
    height: 29.6916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8496_4366",
    x: 0.886068,
    y: -0.518962,
    width: 8.68197,
    height: 27.3583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.583333,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8496_4366",
    x: 2.48698,
    y: -0.947103,
    width: 9.05534,
    height: 9.65489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8496_4366",
    x: 4.78874,
    y: 1.9586,
    width: 2.31608,
    height: 3.29618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291667,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8496_4366",
    x: 1.36328,
    y: 8.15173,
    width: 8.23438,
    height: 20.4437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3125,
    result: "effect1_foregroundBlur_8496_4366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8496_4366",
    x1: 8.4,
    y1: 0.647583,
    x2: 8.4,
    y2: 25.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#41D16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#13972E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8496_4366",
    x1: 8.4,
    y1: 0.647583,
    x2: 8.4,
    y2: 25.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#1639D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8496_4366",
    x1: 7.25645,
    y1: 0.647583,
    x2: 7.25645,
    y2: 25.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#17B434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B792A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8496_4366",
    x1: 5.54063,
    y1: 0.647583,
    x2: 5.54063,
    y2: 25.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#4CD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21AC2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8496_4366",
    x1: 6.69473,
    y1: 11.6705,
    x2: 5.34791,
    y2: 25.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8496_4366",
    x1: 6.68612,
    y1: 11.6705,
    x2: 5.37743,
    y2: 25.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8496_4366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTokenIcon);
export default __webpack_public_path__ + "static/media/green-token-icon.32001fa6a643a4731261a5fd97b5926d.svg";
export { ForwardRef as ReactComponent };